<template>
  <div class="acomodar">
    <div class="border border-1 border-dark mx-2">
      <p class="tituloColorMas mb-0 pb-0 ms-2 mt-1">TESORERIA</p>
      <p class="mt-0 pt-0 ms-2 mb-1 text-secondary tamaños">
        REPORTES GENERALES
      </p>
    </div>

    <div class="border border-1 mx-2 mt-2 pt-2 pb-2 px-3">
      <div class="row">
        <div class="col col-3 ">
          <label for="">Empresa:</label>
          <select
            class="form-select tamaño ms-1 container"
            aria-label="Default select example"
            @change="empresaRuc = $event.target.value"
          >
            <option disabled selected>Seleccionar Empresa..</option>
            <option
              v-for="Empresa in Empresas"
              :key="Empresa.id"
              :value="Empresa.empRuc"
            >
              {{ Empresa.empRazSocial }}
            </option>
          </select>
        </div>

        <div class="col col-3">
          <label> Ejercicio:</label>
          <select
            class="form-select tamaño ms-1 container"
            aria-label="Default select example"
            @change="LlamarCuentaContrable($event.target.value)"
          >
            <option disabled selected>Seleccionar Año..</option>
            <option v-for="años in ListaAños" :key="años.id" :value="años.año">
              {{ años.año }}
            </option>
          </select>
        </div>

        <div class="col col-3  ">
          Cta. Ctb. desde:
            <select
              class="form-select tamaño ms-1 container"
              aria-label="Default select example"
              @change="cuentaContableDesde = $event.target.value"
            >
              <option disabled selected>Seleccionar Cta contable..</option>
              <option v-for="cuenta in cuentaContable" :key="cuenta.id" :value="cuenta.nroCuenta">
                {{ cuenta.nroCuenta }}
              </option>
            </select>
          </div>

          <div class="col col-3  ">
            Cta. Ctb. hasta:
            <select
              class="form-select tamaño ms-1 container"
              aria-label="Default select example"
              @change="cuentaContableHasta = $event.target.value"
            >
              <option disabled selected>Seleccionar Cta contable..</option>
              <option v-for="cuenta in cuentaContable" :key="cuenta.id" :value="cuenta.nroCuenta">
                {{ cuenta.nroCuenta }}
              </option>
            </select>
          </div>

      
      </div>

      <!-- <div class="row">
        <div class="form-check mt-4 col col-2">
          <input
            class="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault2"
            checked
          />
          <label class="form-check-label" for="flexRadioDefault2">
            Fecha
          </label>
        </div>

        <div class="col col-4 mt-4 d-flex">
          Desde:
          <input
            type="date"
            class="form-control tamaño text-secondary ms-2"
            aria-describedby="emailHelp"
            v-model="fechaDesde"
          />
        </div>

        <div class="col col-4 mt-4 ms-3 d-flex">
          Hasta:
          <input
            type="date"
            class="form-control tamaño text-secondary ms-2"
            aria-describedby="emailHelp"
            v-model="fechaHasta"
          />
        </div>
      </div> -->

      <!-- <div class="row">
        <div class="form-check mt-4 col col-2">
          <input
            class="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault2"
            checked
          />
          <label class="form-check-label" for="flexRadioDefault2">
            Periodo
          </label>
        </div>

        <div class="col col-4 mt-4 d-flex">
          Año:
          <input
            type="number"
            class="form-control tamaño text-secondary ms-2"
            aria-describedby="emailHelp"
            min="2015"
            max="2024"
          />
        </div>

        <div class="col col-4 mt-4 ms-3 d-flex">
          Mes:
          <select
            class="form-select tamaño ms-1 container"
            aria-label="Default select example"
          >
            <option disabled selected>Seleccionar Empresa..</option>
            <option
              v-for="meses in ListaMeses"
              :key="meses.id"
              :value="meses.meses"
            >
              {{ meses.meses }}
            </option>
          </select>
        </div>
      </div> -->

      <button @click="descargarReporte" class="btn btn-success mt-3" title="Cuentas x cobrar con vigencia"><i class="bi bi-filetype-xlsx"></i></button>

      <button @click="descargarReporte2" class="btn btn-success mt-3 ms-2" title="Cuentas x cobrar general"><i class="bi bi-filetype-xlsx"></i></button>

      <button @click="descargarReporte3" class="btn btn-success mt-3 ms-2" title="Cuentas x cobrar detalle"><i class="bi bi-filetype-xlsx"></i></button>
    </div>
    <!-- -->
  </div>
</template>

<script>
export default {
  name: "SolimanoLogTesoreriaCuenta",

  data() {
    return {
      Empresas: [],
      empresaRuc: "",
      ListaAños: [
        { id: 1, año: 2015 },
        { id: 2, año: 2016 },
        { id: 3, año: 2017 },
        { id: 4, año: 2018 },
        { id: 5, año: 2019 },
        { id: 6, año: 2020 },
        { id: 7, año: 2021 },
        { id: 8, año: 2022 },
        { id: 9, año: 2023 },
        { id: 10, año: 2024 },
        { id: 11, año: 2025 },

      ],

      ListaMeses: [
        { id: 1, meses: "enero" },
        { id: 2, meses: "febrero" },
        { id: 3, meses: "marzo" },
        { id: 4, meses: "abril" },
        { id: 5, meses: "mayo" },
        { id: 6, meses: "junio" },
        { id: 7, meses: "julio" },
        { id: 8, meses: "agosto" },
        { id: 9, meses: "septiembre" },
        { id: 10, meses: "octubre " },
        { id: 11, meses: "noviembre" },
        { id: 12, meses: "diciembre" },
      ],
      año: "",
      cuentaContable: [],
      cuentaContableDesde:"",
      cuentaContableHasta:"",
      fechaDesde:"",
      fechaHasta:""
    };
  },

  created() {
    this.apiEmpresa();
    this.cambiarEstadoNavbar();
  },
  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    descargarReporte() {
      // Realizar la solicitud Axios cuando se hace clic en el botón
      this.axios.get(`ReportesExcel/ReporteCuentasxCobrar?rucEmpresa=${this.empresaRuc}&cuentaDesde=${this.cuentaContableDesde}&cuentaHasta=${this.cuentaContableHasta}`, {
        responseType: 'blob' // Indica a Axios que la respuesta es un archivo binario
      
      })
      .then(response => {
          // Crear un enlace temporal para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'reporte.xlsx'); // Nombre del archivo
          document.body.appendChild(link);
          link.click();

          // Limpiar el enlace y liberar recursos
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('Error al descargar el reporte:', error);
        });
    },

    descargarReporte2() {
      // Realizar la solicitud Axios cuando se hace clic en el botón
      this.axios.get(`ReportesExcel/ReporteCuentasxCobrarGeneral?rucEmpresa=${this.empresaRuc}&cuentaDesde=${this.cuentaContableDesde}&cuentaHasta=${this.cuentaContableHasta}`, {
        responseType: 'blob' // Indica a Axios que la respuesta es un archivo binario
      
      })
      .then(response => {
          // Crear un enlace temporal para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'reporte1.xlsx'); // Nombre del archivo
          document.body.appendChild(link);
          link.click();

          // Limpiar el enlace y liberar recursos
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('Error al descargar el reporte:', error);
        });
    },

    descargarReporte3() {
      // Realizar la solicitud Axios cuando se hace clic en el botón
      this.axios.get(`ReportesExcel/ReporteCuentasxCobrarDetalle?rucEmpresa=${this.empresaRuc}&cuentaDesde=${this.cuentaContableDesde}&cuentaHasta=${this.cuentaContableHasta}`, {
        responseType: 'blob' // Indica a Axios que la respuesta es un archivo binario
      
      })
      .then(response => {
          // Crear un enlace temporal para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'reporte2.xlsx'); // Nombre del archivo
          document.body.appendChild(link);
          link.click();

          // Limpiar el enlace y liberar recursos
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('Error al descargar el reporte:', error);
        });
    },

    apiEmpresa() {
      this.axios.get(`Empresa/ListaEmpresa`).then((r) => {
        console.log(r.data);
        this.Empresas = r.data;
      });
    },

    LlamarCuentaContrable(event) {
      this.año = event;
      if (this.empresaRuc != "" && this.año != "") {
        this.axios
          .get(
            `Tesoreria/ListarCuentas?rucEmpresa=${this.empresaRuc}&periodo=${this.año}`
          )
          .then((r) => {
            console.log(r.data);
            this.cuentaContable = r.data;
          });
      }
    },
  },
};
</script>
<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  padding-bottom: 2%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 1%;
  margin-right: 1%;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: hidden;
}

.tamaño {
  font-size: 0.65rem;
}
</style>
